<form [formGroup]="form" class="dynamic-form">
  <ng-container *ngFor="let question of questions">
    <app-question
      [question]="question"
      [textareaTip]="textareaTip"
      [form]="form"
      [formError]="formError"
      class="{{ question?.class || '' }}"
    ></app-question>
  </ng-container>
  <button
    type="button"
    *ngIf="!hideSubmit"
    (click)="onSubmit()"
    [disabled]="submitDisabled"
    class="btn btn--primary float--right"
    [ngClass]="{ tooltipDisabled: submitDisabled }"
    title="{{ submitDisabled ? 'actions.fillForm' : ('actions.save' | translate) }} {{
      submitDisabled ? '' : form.value.name
    }}"
  >
    {{ 'actions.save' | translate }}
  </button>
  <ng-content select="[form-actions-after]"></ng-content>
</form>
